/**
 * @flow
 * @relayHash 780887f06009066c9d928b97395d16d7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ContentLoaderQueryVariables = {|
  tag?: ?string
|};
export type ContentLoaderQueryResponse = {|
  +content: ?string
|};
export type ContentLoaderQuery = {|
  variables: ContentLoaderQueryVariables,
  response: ContentLoaderQueryResponse,
|};
*/


/*
query ContentLoaderQuery(
  $tag: String
) {
  content(tag: $tag)
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "tag",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "content",
    "args": [
      {
        "kind": "Variable",
        "name": "tag",
        "variableName": "tag"
      }
    ],
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ContentLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ContentLoaderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ContentLoaderQuery",
    "id": null,
    "text": "query ContentLoaderQuery(\n  $tag: String\n) {\n  content(tag: $tag)\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '791376c18ab394a99590e2eb995e52b8';
module.exports = node;
